module.exports = __webpack_public_path__ + "img/general.415c660a.webp";